import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'loader-report',
  templateUrl: './loader-report.component.html',
  styleUrls: ['./loader-report.component.scss']
})
export class LoaderReportComponent implements OnInit {
  

  @Input() state?: string;
  @Input() position?: 'bottom' | 'middle' | 'top';
  
  ngOnInit(): void {
    console.log(this.state)
  }
}
